const keys: Array<string> = [
  'general.button.signin',
  'bonuspoints.title',
  'bp.howitworks',
  'bp.products',
  'bp.terms',
  'mzp.navigation.mobileMenuTitle',
  'bp.publicMenu.navigation',
  'bp.publicMenu.link.howItWorks',
  'bp.publicMenu.link.products',
  'bp.publicMenu.link.terms',
];

export default keys;
